import React, { forwardRef } from 'react'
import { InputFieldProps } from './types'
import { Input as CoreInput, Form } from 'antd'
import styles from './InputField.module.scss'

const BaseInput = forwardRef<HTMLElement, InputFieldProps>(function BaseInput(
  props,
  ref
) {
  const {
    onChange,
    label,
    mask,
    help,
    validateStatus,
    className,
    isVisible,
    type,
    style,
    labelCol,
    wrapperCol,
    ...rest
  } = props
  const [passwordVisible, setPasswordVisible] = React.useState(false)
  const Input = isVisible ? CoreInput.Password : CoreInput

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: val } = event.target
    onChange && onChange(val)
  }

  return (
    <Form.Item
      style={style ? style : { }}
      className={className ? className : styles.ibinput}
      label={label}
      {...(labelCol ? { labelCol }: {})}
      {...(wrapperCol ? { wrapperCol }: {})}
      {...(validateStatus ? { validateStatus }: {})}
      {...(help ? { help }: {})}
    >
      <Input
        ref={ref}
        autoComplete="off"
        onChange={handleChange}
        {...(isVisible
          ? {
              visibilityToggle: {
                visible: passwordVisible,
                onVisibleChange: setPasswordVisible,
              },
            }
          : {})}
        {...rest}
      />
    </Form.Item>
  )
})

export default BaseInput
